import {SET_POSTS} from 'constants/actionTypes';

export const setPosts = payload => ({type: SET_POSTS, payload});
